import { Injectable } from '@angular/core';
import { Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { TransientReservationSearchParameters } from '../models/transient-reservation-search-params';
import { Reservation, TransientReservation } from '../models/reservation';
import { LinkReservationRequest } from '../models/link-reservation-request';
import { AppAuthHttpService } from '../../http/app.auth.http.service';
import { Page } from '../../shared/models/page';
import { UnlinkReservationRequest } from '../models/unlink-reservation-request';

@Injectable()
export class TransientReservationService {

  private eventUrl: string = this.environment.baseUrl + '/api/events';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  search(searchParameters: TransientReservationSearchParameters, page: number, size: number): Observable<Page<TransientReservation>> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers }); // Create a request option
    const reservationAsJSON = JSON.stringify(searchParameters.toJS());

    return this.http.post(`${this.eventUrl}/transient/reservations/search?page=${page}&size=${size}`, reservationAsJSON, options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  linkTransientReservationsToEvent(eventReservationIdList: number[], eventPartyId: number,
                                  doNotPay?: boolean): Observable<Response> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    const request = new LinkReservationRequest({
      eventReservationIdList: eventReservationIdList,
      payViaGp: doNotPay ? false : true,
      eventPartyId: eventPartyId
    });
    const requestAsJSON = JSON.stringify(request);
    const result = this.http.post(`${this.eventUrl}/transient/reservations/link-to-event`, requestAsJSON, options)
      .catch(response => this.responseUtilService.handleError(response))
      .share();
    return result;
  }

  unlinkTransientReservation(eventReservationId: number, eventId: number): Observable<Reservation> {
    let result;
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    const request = new UnlinkReservationRequest({
      eventReservationId: eventReservationId,
      eventId: eventId
    });
    const requestAsJSON = JSON.stringify(request);
    result = this.http.post(`${this.eventUrl}/transient/reservations/unlink`, requestAsJSON, options)
      .map(response => new Reservation(response))
      .catch(response => this.responseUtilService.handleError(response))
      .share();
    return result;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/transient-reservation-http-service.ts